export default (id) => {

  return id?.indexOf('theme-') > -1;
};
